import { useState } from "react";
import { useLogicTerms } from "./TermChip";
import LogicFrame from "./LogicFrame";
import { useLogicUi } from "./logicUi";

export default function LogicGlossary() {
  const terms = useLogicTerms();
  const { ui, L } = useLogicUi();
  const [openId, setOpenId] = useState(null);
  return (
    <LogicFrame title={ui.glossaryTitle} seoTitle="The Terms of the Discipline" crumb={ui.theTerms} testid="logic-glossary-page">
      <p className="text-fog/80 font-reading max-w-2xl mb-12 leading-[1.9]">{ui.glossaryIntro}</p>
      <div className="space-y-3">
        {terms.map((t) => {
          const open = openId === t.id;
          return (
            <div key={t.id} className="border border-[#c8a95a]/20 bg-[#171c26]">
              <button data-testid={`glossary-term-${t.id}`} onClick={() => setOpenId(open ? null : t.id)} aria-expanded={open}
                className="w-full text-left px-6 py-4 flex items-baseline justify-between gap-4 focus:outline-none focus:ring-2 focus:ring-gold/60">
                <span className="flex items-baseline gap-4">
                  <span className="font-serif text-lg text-gold">{t.transliteration}</span>
                  <span className="font-serif text-base text-bone/40">{t.original}</span>
                </span>
                <span className="text-gold/60" aria-hidden>{open ? "−" : "+"}</span>
              </button>
              {open && (
                <div className="px-6 pb-6 space-y-4" data-testid={`glossary-detail-${t.id}`}>
                  <p className="text-[15px] text-bone/90 font-reading leading-[1.85]">{L(t.plain)}</p>
                  <p className="text-sm text-fog font-reading leading-[1.85]"><span className="text-gold/70 text-xs tracking-[0.2em] uppercase">{ui.academic} </span>{L(t.academic)}</p>
                  <p className="text-sm text-fog/85 font-reading leading-[1.85]"><span className="text-gold/70 text-xs tracking-[0.2em] uppercase">{ui.inCourse} </span>{L(t.application)}</p>
                  <p className="text-sm text-fog/70 font-reading italic leading-[1.85]">{L(t.example)}</p>
                  <div className="flex flex-wrap gap-x-6 gap-y-2 pt-3 border-t border-white/10 text-[11px] tracking-[0.15em] uppercase">
                    {t.related?.length > 0 && (
                      <span className="text-[#8fa3c8]">{ui.related} {t.related.map((r) => terms.find((x) => x.id === r)?.transliteration || r).join(", ")}</span>
                    )}
                    {t.lessons?.length > 0 && <span className="text-fog/50">{ui.lessons} {t.lessons.join(", ")}</span>}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </LogicFrame>
  );
}
